import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { DateFormatService } from 'dmmp-services'

@Component({
  selector: 'dmmp-related-content',
  templateUrl: './related-content.component.html',
})
export class RelatedContentComponent implements OnInit {
  @Input() title
  @Input() date
  @Input() path
  @Input() defaultClass
  @Output() page = new EventEmitter()

  constructor(private dateFormat: DateFormatService) {
  }

  ngOnInit() {
    this.date = this.dateFormat.convertFromTimestampToDate(this.date)
  }
}
